package com.example.mystybag.sharedmodels.project.responseModels.merchant

import kotlinx.serialization.Serializable

@Serializable
data class MerchantLocationResponseModel(
    val id: Long = 0L,
    val merchantId: Long = 0L,
    val title: String? = null,
    /** Root-level products of the location's catalog (name + grams + …). */
    val products: List<ProductModel> = emptyList(),
    val address: String? = null,
    val cityId: Long = 0L,
    val cityName: String? = null,
    val latitude: Float = -1f,
    val longitude: Float = -1f,
    val dialCode: String = "",
    val phoneNumber: String = "",
    val packaging: String? = null,
    val additionalPickupInstructions: String? = null,
    val surpriseBagContainsBuffetFood: Boolean = false,
    val businessCategoryId: Long? = null,
    val businessCategoryTitle: String? = null,
    val coverPhotoUrl: String? = null,
    val menuPhotoUrls: List<String> = emptyList(),
    val employeesCount: Int = 0,
    val activeBagsCount: Int = 0
)

